import { css } from 'linaria';
import { styled } from 'linaria/react';

export const Content = styled.div`
  display: flex;
  gap: var(--space-300);
  margin-bottom: var(--space-500);

  @media (max-width: 1386px) {
    margin-bottom: var(--space-400);
  }

  @media (max-width: 1023px) {
    margin-bottom: var(--space-400);
  }

  @media (max-width: 767px) {
    margin-top: var(--space-225);
    margin-bottom: var(--space-500);
  }

  @media (max-width: 389px) {
    margin-top: var(--space-225);
    margin-bottom: var(--space-500);
  }
`;

export const tabStyles = css`
  cursor: pointer;
  &:disabled {
    color: var(--text-minor);
    cursor: not-allowed;
  }
`;
